<script>
import { mapGetters, mapActions } from "vuex";

import AdminContractPage from "../components/AdminContractLotinPage.vue";

import ChooseLocale from "../components/ChooseLocale.vue";
import sizeVue from "../mixins/size.vue";

export default {
  name: "Home",

  components: { ChooseLocale, AdminContractPage },

  data: () => ({
    isContract: false,
    pdfData: false,
  }),

  mixins: [sizeVue],

  computed: {
    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    menuItems: (vm) =>
      vm.$toArray(vm.user.menus)
        .map((x) => {
          x._width = vm.getTextSize(x.name);
          return x;
        })
        .sort((a, b) => a.order - b.order),
    appBarHeight: (vm) => (vm.size.width > 780 ? 96 : 140),

    ...mapGetters("application", { application: "GET_APPLICATION" }),
  },

  created() {
    if (this.$route.path != "/application") {
      this.INIT_APPLICATION();
    }
  },

  mounted() {
    const app = document.body.querySelector(".v-application");
    app.style.background = "#f3eefb";
  },

  methods: {
    ...mapActions("auth", ["LOGOUT"]),
    ...mapActions("application", ["INIT_APPLICATION"]),

    onExit() {
      this.LOGOUT();
    },

    getTextSize(name) {
      const span = document.createElement("a");
      span.style.height = "0";
      span.style.overflow = "hidden";
      span.style.display = "inline-block";
      span.style.whiteSpace = "nowrap";
      span.innerText = name;
      span.id = name;
      span.style.fontFamily;

      const parent = document.querySelector("#_dont_remove__text_size");
      parent.appendChild(span);

      let width = span.offsetWidth + 50;
      parent.removeChild(span);
      return width + "px";
    },

    async onDownloadContract() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`abiturient/contract/${id}`);
      if (data) {
        this.pdfData = data;
        this.$nextTick(() => (this.isContract = true));
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div>
    <admin-contract-page
      v-if="isContract && pdfData"
      :pdfData="pdfData"
      @close="
        () => {
          isContract = false;
          loading = false;
        }
      "
    />

    <v-app-bar
      fixed
      elevate-on-scroll
      elevation="1"
      color="#FFCB05"
      :height="appBarHeight"
    >
      <v-container>
        <div class="align-center header-wrap">
          <img
            src="../assets/img/logo-inline.png"
            style="max-width: 200px"
            alt=""
          />
          <v-spacer />

          <div class="d-flex align-center">
            <v-spacer />
            <div
              v-if="
                application.status == 'EXAMINED' ||
                application.status == 'PASSED'
              "
              class="px-2 text-uppercase ball"
            >
              <!--              <b>
                {{
                  $t("toplagan bali") +
                  " " +
                  application.ball +
                  " " +
                  $t("ball")
                }}
              </b>-->
            </div>
            <div
              v-if="application.paid && application.status == 'PASSED'"
              @click="onDownloadContract"
              class="accent--text px-2 cursor-pointer text-uppercase"
            >
              <b> {{ $t("download_сontract") }} </b>
            </div>
            <div class="accent--text px-2">{{ user.phone }}</div>
            <choose-locale />
            <v-btn
              text
              @click="onExit"
              large
              class="transform-none"
              color="accent"
              style="border-radius: 0"
            >
              {{ $t("Exit") }}
            </v-btn>
          </div>
        </div>
      </v-container>
    </v-app-bar>
    <div :style="{ height: appBarHeight + 'px' }" />

    <!-- <div class="sticky-header"> -->
    <div class="sub-menu-wrap">
      <v-container>
        <div class="sub-menu">
          <swiper
            :options="{
              slidesPerView: 'auto',
              spaceBetween: 10,
            }"
          >
            <swiper-slide
              :style="{ width: item._width }"
              v-for="item in menuItems"
              :key="item.name"
            >
              <div
                class="sub-menu-item"
                :ref="item.route"
                :class="item.route == $route.path && 'sub-menu-item-active'"
              >
                <router-link :to="item.route">
                  {{ item.name }}
                </router-link>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </v-container>
    </div>
    <!-- </div> -->

    <v-main>
      <router-view />
    </v-main>
  </div>
</template>

<style lang="scss">
.swiper-slide {
  width: auto;
}

.sub-menu-wrap {
  background-color: white;

  .sub-menu {
    margin-top: 5px;

    .sub-menu-item {
      display: inline-block;
      padding-bottom: 14px;
      color: var(--v-accent-base);

      a {
        color: inherit;
        text-decoration: none;

        display: inline-block;
        padding: 0 10px;
      }

      &.sub-menu-item-active {
        border-bottom: 2px solid var(--v-accent-base);
        color: var(--v-accent-base);

        a {
          background-color: var(--v-accent-base);
          color: var(--v-secondary-base);
        }
      }
    }
  }
}

.sticky-header {
  width: 100%;
  top: 0px;
  position: sticky;
  background-color: white;
  z-index: 1;
}

.header-wrap {
  @media only screen and(min-width:780px) {
    display: flex;
  }
}

.ball {
  font-family: "Inter", sans-serif;
  margin-right: 25px;
}

@media (max-width: 600px) {
  .header-wrap .d-flex { flex-wrap: wrap; justify-content: flex-end; row-gap: 4px; column-gap: 8px; }
}
</style>
